"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPartCompositionTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _Permissions = require("../../constants/Permissions");
var _DmsFlexContainer = require("../DmsFlexContainer/DmsFlexContainer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsPartCompositionTable Component
 *
 * @description Renders a table for managing part compositions in the DMS roles page.
 * Includes options for creating, editing, and deleting part compositions based on user permissions.
 *
 * @component
 * @example
 * return (
 *   <DmsPartCompositionTable />
 * )
 *
 * @returns {JSX.Element} Table component for managing part compositions.
 */
const DmsPartCompositionTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Parent").d("Parent"),
    column_name: "parent_part",
    control: 'select',
    url: "/part/all",
    properties: {
      column_name: "name",
      text_template: '{name}'
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Composite").d("Composite"),
    column_name: "composite_part",
    control: 'select',
    url: "/part/all",
    properties: {
      column_name: "name",
      text_template: '{name}'
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Quantity").d("Quantity"),
    column_name: "quantity",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    column_name: "actions",
    permissions: [_Permissions.Permissions.CAN_EDIT_PART],
    width: "80px",
    sortable: false,
    element: row => {
      const quantity = row.quantity;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Updatepartcomposition_name", {
          quantity
        }).d("Update {quantity}"),
        url: "/part_composition/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Deletepartcomposition_name", {
          quantity
        }).d("Delete {quantity}"),
        text: _reactIntlUniversal.default.get("DmsPartCompositionTable.DeleteButtonMessage", {
          quantity
        }).d("The part composition with quantity {quantity} will be deleted. Are you sure about it?"),
        url: "/part_composition/",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    header: header,
    table: table,
    title: _reactIntlUniversal.default.get("Createpartcomposition").d("Create part composition"),
    url: '/part_composition'
  }))));
  return /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    export_table: false,
    ref: table,
    url: '/part_composition/table',
    toolbar: toolbar
  });
};
exports.DmsPartCompositionTable = DmsPartCompositionTable;